import { parseAsArrayOf, parseAsBoolean, parseAsInteger, parseAsString, parseAsStringLiteral } from 'nuqs';

import { SearchSoldoutEnum, SearchSortEnum } from '~/apis/search';
import { SearchFilterKey, SearchFilterState } from '~/types';

export const SOLD_OUT_OPTIONS: SearchSoldoutEnum[] = ['include', 'exclude'];

export const SORT_OPTIONS: SearchSortEnum[] = [
  'date',
  'raw_date',
  'distance',
  'score',
  'model',
  'popular',
  'price_asc',
  'price_desc',
  'pfavcnt_desc',
  'interest_desc',
  'create_date_desc',
  'create_date_asc',
  'unknown',
  'none',
];

export const SEARCH_FILTER_KEYS: SearchFilterKey[] = [
  'categoryId',
  'q',
  'bunPay',
  'bunCare',
  'brandId',
  'maxPrice',
  'minPrice',
  'location',
  'freeShipping',
  'modelId',
  'proshop',
  'soldout',
  'sort',
  'minCreatedAt',
  'used',
  'view',
  'within',
];

export const getSearchFilterSearchParams = (rawSearchFilter: object) => {
  const searchFilter: SearchFilterState = {};

  for (const [key, value] of Object.entries(rawSearchFilter)) {
    if (SEARCH_FILTER_KEYS.find((v) => v === key)) {
      if (value === null) continue;
      searchFilter[key as SearchFilterKey] = value;
    }
  }

  return searchFilter;
};

export const SEARCH_FILTER_SEARCH_PARAMS = {
  q: parseAsString,
  categoryId: parseAsArrayOf(parseAsString),
  bunPay: parseAsBoolean,
  bunCare: parseAsBoolean,
  brandId: parseAsArrayOf(parseAsInteger),
  minPrice: parseAsInteger,
  maxPrice: parseAsInteger,
  location: parseAsString,
  freeShipping: parseAsBoolean,
  modelId: parseAsArrayOf(parseAsInteger),
  proshop: parseAsBoolean,
  soldout: parseAsStringLiteral(SOLD_OUT_OPTIONS),
  sort: parseAsStringLiteral(SORT_OPTIONS),
  minCreatedAt: parseAsString,
  used: parseAsBoolean,
  view: parseAsString,
  within: parseAsString,
};
